<div class="item" (click)="modal.open()">
    <div class="item__icon"></div>
    <div class="item__title" [innerHTML]="data.title?.value"></div>
    <div class="item__arrow"></div>
</div>

<digital-book-modal #modal [bookUrl]="data.issuuUrl?.value"></digital-book-modal>
